import { render, staticRenderFns } from "./SnackDisplayer.vue?vue&type=template&id=0afd80c2"
import script from "./SnackDisplayer.vue?vue&type=script&lang=js"
export * from "./SnackDisplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports